import type { VideoService } from '../types'

export class SingleFilm {
  private container: HTMLElement | null
  private playerCanvas: Element | null = null
  private video: Element | null = null
  private playButton: Element | null = null
  private videoService: VideoService | undefined
  private videoServiceId: string | undefined

  constructor() {
    this.container = document.querySelector('#js-single-film') as HTMLElement

    if (!this.container) {
      return
    }

    this.playerCanvas = this.container.querySelector('#js-player-canvas')
    this.video = this.playerCanvas?.querySelector('#js-video') || null
    this.playButton = this.playerCanvas?.querySelector('#js-playbutton') || null

    const videoElement = this.video as HTMLElement
    this.videoService = videoElement?.dataset.service as VideoService
    this.videoServiceId = videoElement?.dataset.serviceId

    this.toggleMore()
    this.loadVideo()
    this.scrollProgress()
  }

  toggleMore(): void {
    const synopsisToggle = document.querySelector('.js-synopsis-toggle')
    if (synopsisToggle) {
      synopsisToggle.addEventListener('click', () => {
        const synopsis = document.querySelector('#js-synopsis')
        synopsis?.classList.add('show-full')
        synopsisToggle.setAttribute('aria-expanded', 'true')
        this.scrollProgress()
      })
    }

    const castToggle = document.querySelector('.js-cast-toggle')
    if (castToggle) {
      castToggle.addEventListener('click', () => {
        const people = document.querySelector('#js-people')
        people?.classList.add('show-full')
        castToggle.setAttribute('aria-expanded', 'true')
        this.scrollProgress()
      })
    }
  }

  loadVideo(): void {
    if (!this.playButton || !this.video) return
    
    this.playButton.addEventListener('click', () => {
      this.playerCanvas?.classList.add('video-playing')

      let embedHtml = ''

      // Append YouTube embed code
      if (this.videoService === 'YouTube') {
        embedHtml = `<div class="video-wrapper"><iframe width="960" height="540" src="//www.youtube-nocookie.com/embed/${this.videoServiceId}?autoplay=1" frameborder="0" allowfullscreen></iframe></div>`
      }
      // Append Vimeo embed code
      else if (this.videoService === 'Vimeo') {
        embedHtml = `<div class="video-wrapper"><iframe src="//player.vimeo.com/video/${this.videoServiceId}?title=1&byline=0&portrait=0&autoplay=1" width="960" height="540" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`
      }

      this.video?.insertAdjacentHTML('beforeend', embedHtml)
    })
  }

  scrollProgress(): void {
    if (!this.container) return
    
    const scrollArea = this.container.querySelector('.js-info-innerscroll') as HTMLElement
    const progressBar = this.container.querySelector('#js-progressbar') as HTMLElement
    const progress = progressBar?.querySelector('#js-progress') as HTMLElement | null
    const outerScroll = this.container.querySelector('.js-info-outerscroll') as HTMLElement
    const info = this.container.querySelector('.js-info') as HTMLElement

    if (!scrollArea || !progressBar || !progress || !outerScroll || !info) return

    const outerHeight = Math.floor(outerScroll.clientHeight)
    const innerHeight = Math.floor(info.offsetHeight)

    if (innerHeight < outerHeight) {
      progressBar.style.display = 'none'
      return
    }

    const initialProgress = 100 - Math.round(((innerHeight - outerHeight) / innerHeight) * 100)
    progress.style.height = `${initialProgress}%`

    progressBar.style.display = 'block'
    progressBar.style.opacity = '1'

    // Remove previous scroll listener and add new one
    const handleScroll = () => {
      const scrollProgress = Math.round((scrollArea.scrollTop / innerHeight) * 100)
      progress.style.height = `${initialProgress + scrollProgress}%`
    }

    scrollArea.removeEventListener('scroll', handleScroll)
    scrollArea.addEventListener('scroll', handleScroll)
  }
}
